var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索机构...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchEntity
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  })], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadEntity
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateEntityDrawer();
      }
    }
  }, [_vm._v("新增机构")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.entityList,
      "height": _vm.tableHeight
    }
  })], 1), _c('EditEntityDrawer', {
    ref: "EditEntityDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }